import {
  ADD_NODE, REMOVE_NODE, LOAD, UPDATE_CMS_EDITOR, CMS_EDITOR_LOADED,
  CMS_EDITOR_LOADING
} from '../actions/club-cms';
import { CmsEditorState } from '../api/club-cms';
import Club from "../api/club";


class ClubCmsState {
  cmsEditorState: CmsEditorState;
  loading: boolean;

  constructor() {
    this.cmsEditorState = new CmsEditorState();
    this.loading = false;
  }
}

interface IAction {
  type: string;
  cmsEditorState: CmsEditorState;
  club: Club;
}

const initState: ClubCmsState = new ClubCmsState();

export default function(state: ClubCmsState = initState, action: IAction) {
  let { type, cmsEditorState, club } = action;

  switch (type) {
    case CMS_EDITOR_LOADING:
      return Object.assign(new ClubCmsState(), state, {
        loading: true
      });
    case UPDATE_CMS_EDITOR:
      return Object.assign(new ClubCmsState(), state, {
        cmsEditorState
      });

    case CMS_EDITOR_LOADED:
      return Object.assign(new ClubCmsState(), state, {
        loading: false,
        cmsEditorState,
        club
      });


    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/reducers/club-cms.ts